var _path, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrTabbarIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "transparent",
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "gr-tabbar-icon-bottom",
    d: "M6 16H24V23C24 24.6569 22.6569 26 21 26H9C7.34315 26 6 24.6569 6 23V16Z",
    stroke: "#FFBF00",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "gr-tabbar-icon-hat"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24 15L6 15C5.44772 15 5 14.5523 5 14L5 12C5 11.4477 5.44772 11 6 11L24 11C24.5523 11 25 11.4477 25 12L25 14C25 14.5523 24.5523 15 24 15Z",
    stroke: "#FFBF00",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 16V10.5",
    stroke: "#FFBF00",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16 8H20C21.1046 8 22 7.10457 22 6C22 4.89543 21.1046 4 20 4H19C17.3431 4 16 5.34315 16 7V8Z",
    stroke: "#FFBF00",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 8H14V7C14 5.34315 12.6569 4 11 4H10C8.89543 4 8 4.89543 8 6C8 7.10457 8.89543 8 10 8Z",
    stroke: "#FFBF00",
    strokeWidth: 2
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "gr-tabbar-icon-sparkles"
  }, /*#__PURE__*/React.createElement("path", {
    className: "gr-tabbar-icon-sparkle",
    d: "M27.9986 13.5167L30.1846 14.7788",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gr-tabbar-icon-sparkle",
    d: "M27.9996 8.93332L30.4509 7.51804",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gr-tabbar-icon-sparkle",
    d: "M25.4133 5.82741V3.29759",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrTabbarIcon);
export default __webpack_public_path__ + "static/media/gr_tabbar_icon.82fbaedd8ff71fb816510140a536e3a9.svg";
export { ForwardRef as ReactComponent };